import { gql } from '../../__generated__/graphql/catalog'

export const FETCH_REVIEW_PRODUCT_GROUP = gql(`
  query FetchReviewProductGroup($handle: String!) {
    product(handle: $handle) {
      color
      handle
      seoTitle
      shopifyId
      title
      images {
        nodes {
          source
        }
      }
      productGroup {
        handle
      }
    }
  }
`)
